'use strict'
const	ApiService = require('../_provider.api'),
			Axios 			= require('axios'),
			config		= require('main.config')
class NotificationService extends ApiService {
	constructor(init) {
		super(init);
	}

	getNotificationUnreadCount(accountId) {
		let data = {
			'query' : "query get_unread_count($applicationId: Int!, $accountId: Int!){unreadCount(applicationId: $applicationId, targetId: $accountId)}",
			'variables': {
				applicationId: config.activityStreamAppId,
				accountId: accountId
			},
			operationName: 'get_unread_count'
		};
		return Axios({
			method  : 'POST',
			url     : config.activityStreamBaseUrl + '/graphql',
			data    : JSON.stringify(data),
			headers : {
				'Content-Type': 'application/json',
				'x-as-appid': config.activityStreamAppId,
			},
			withCredentials: true
		})
	}
	getAppBadgeNumbers(sessionId){
		return this.get({
			url : 'v2/mobile_apps/self/badges',
			headers: {
				'Content-Type': 'application/json'
			},
			withCredentials: true
		});
	}
}

module.exports = NotificationService



// WEBPACK FOOTER //
// providers/providers/Notification.js